import React from "react";

const DateComponent = ({ title, dateString }) => {
  const date = new Date(dateString);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const weekday = weekdays[date.getDay()];
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  return (
    <div className="border border-gray-200 rounded-md h-full w-1/4 lg:w-[10%]">
      <div className="w-full font-bold text-center text-white text-xl bg-[#57b3dd] rounded-t-md mb-2">
        {title}
      </div>
      <div className="flex flex-col items-center mb-2">
        <div className="w-full text-center text-md font-semibold">{`${weekday} ${month}`}</div>
        <div className="w-full text-center text-4xl font-bold tracking-tight">
          {day}
        </div>
        <div className="w-full text-center text-md font-semibold">{year}</div>
      </div>
    </div>
  );
};

export default DateComponent;
